/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Rule_AlwaysInputs */

const en_pb_rule_always = /** @type {(inputs: Pb_Rule_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always`)
};

const id_pb_rule_always = /** @type {(inputs: Pb_Rule_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selalu`)
};

/**
* | output |
* | --- |
* | "Always" |
*
* @param {Pb_Rule_AlwaysInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_rule_always = /** @type {((inputs?: Pb_Rule_AlwaysInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Rule_AlwaysInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_rule_always(inputs)
	return en_pb_rule_always(inputs)
});